import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import type { ISearchChallengeV2Result } from './search-challenges-v2-response';
import { searchChallengesV2ResponseSchema } from './search-challenges-v2-response';

export async function searchChallengesV2Api(query: string) {
  return getRequest<IAPI<ISearchChallengeV2Result[]>>({
    path: '/challenges/v2/search',
    options: { params: { query } },
    schema: searchChallengesV2ResponseSchema,
  });
}
